/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 * @Date: 2020-12-24 19:30:59
 * @LastEditTime: 2020-12-24 20:04:58
 */

const mutation = {
  // 设置用户信息
  SET_PAGE_TEXT: (state, pageText) => {
    state.pageText = pageText || {}
  }
}
export default mutation
